import { Ferramenta } from "./entities/Ferramenta";
import { Grupo } from "./entities/Grupo";
import { Checklist } from "./entities/Checklist";
import { Funcionario } from "../funcionario/entities/Funcionario";
import { Fornecedor } from "./entities/Fornecedor";
import { Documento } from "./entities/Documento";
import { Movimentacao } from "./entities/Movimentacao";
import { RelatorioMovimentacoes } from "./entities/RelatorioMovimentacoes";
// import { RelatorioFerramentas } from "./ferramentasAdm/entities/RelatorioFerramentas";

const actions = {
  criarFerramenta: async (
    context,
    {
      unidadeId,
      nome,
      descricao,
      preco,
      patrimonio,
      permanencia,
      grupo,
      origem,
      serie,
      documento,
      fornecedorId,
      responsavelId,
      tipo_documento,
      valor_locacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const resposta = await api.post(`ferramentas`, {
      vendor_id: unidadeId,
      nome: nome,
      descricao: descricao,
      preco: preco,
      tempo_permanencia: permanencia,
      patrimonio: patrimonio,
      grupo_ferramenta_uuid: grupo,
      origem: origem,
      serie: serie,
      documento: documento,
      provider_id: fornecedorId,
      responsavel_id: responsavelId,
      tipo_documento,
      valor_locacao,
    });

    return {
      resposta,
    };
  },

  movimentaStatus: async (
    context,
    { uuid, status, observacao, fornecedor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.put(`ferramentas/${uuid}/movimentar-status`, {
      status: status,
      observacao: observacao,
      fornecedor_id,
    });
  },

  deletarFerramenta: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.delete(`ferramentas/${uuid}`);
  },

  deletarImagem: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.delete(`ferramentas/${uuid}/apagar-imagem`);
  },

  listarFerramentas: async (
    context,
    { unidadeId, perPage, filtro, status, page, categoria, grupo, patrimonio }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(`ferramentas/paginado`, {
      params: {
        vendor_id: unidadeId,
        per_page: perPage,
        nome: filtro,
        page,
        status,
        categoria,
        grupo,
        patrimonio,
      },
    });

    return {
      resposta,
    };
  },
  listarFerramentasChecklist: async (
    context,
    { deposito, filtro, per_page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(`ferramentas`, {
      params: {
        deposito,
        nome: filtro,
        objetos: "check-list",
        per_page,
      },
    });

    return {
      resposta,
    };
  },

  AssosiarChecklist: async (context, { check_uuid, check_lists }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.put(
      `ferramentas/${check_uuid}/adicionar-check-list`,
      {
        check_lists,
        check_uuid,
      }
    );

    return {
      resposta,
    };
  },

  RemoverChecklist: async (context, { check_uuid, check_lists }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.put(
      `ferramentas/${check_uuid}/remover-check-list`,
      {
        check_lists,
        check_uuid,
      }
    );

    return {
      resposta,
    };
  },

  listarFerramentasDisponiveis: async (
    context,
    { responsavelId, unidadeId }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(
      `ferramentas/listar-ferramentas/liberadas-por-funcionario`,
      {
        params: {
          user_id: responsavelId,
          vendor_id: unidadeId,
          status: "disponivel",
        },
      }
    );

    resposta = resposta.data;

    let listaFerramentasDisponiveis = [];

    if (resposta.result.length > 0) {
      resposta.result[0].ferramentas.forEach((ferramentaDTO) => {
        listaFerramentasDisponiveis.push(
          new Ferramenta({
            uuid: ferramentaDTO.ferramenta_uuid,
            nome: ferramentaDTO.nome_ferramenta,
            descricao: ferramentaDTO.descricao,
            unidadeId: ferramentaDTO.vendor_id,
            responsavelId: ferramentaDTO.responsavelId,
            permanencia: ferramentaDTO.tempoPermanencia,
            status: ferramentaDTO.status_ferramenta,
            patrimonio: ferramentaDTO.patrimonio,
          })
        );
      });
    }

    return {
      listaFerramentasDisponiveis,
    };
  },

  listarFerramentasDevolver: async (context, { responsavelId, unidade }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`ferramentas/listar-ferramentas/por-usuario`, {
      params: {
        entregue: "0",
        user_id: responsavelId,
        vendorId: unidade,
      },
    });

    resposta = resposta.data;
    let listaFerramentasDevolver = [];

    if (resposta.result.length > 0) {
      resposta.result.forEach((ferramentaDTO) => {
        listaFerramentasDevolver.push(
          new Ferramenta({
            responsavelNome: ferramentaDTO.nome_funcionario,
            uuid: ferramentaDTO.ferramenta_uuid,
            nome: ferramentaDTO.nome_ferramenta,
            movimentacao_uuid: ferramentaDTO.movimentacao_uuid,
            descricao: ferramentaDTO.descricao_ferramenta,
            unidadeId: ferramentaDTO.nome_vendor,
            responsavelId: ferramentaDTO.responsavelId,
            permanencia: ferramentaDTO.tempoPermanencia,
            status: ferramentaDTO.status_ferramenta,
            patrimonio: ferramentaDTO.patrimonio,
            checklist: ferramentaDTO.checkLists,
            dataRetirada:
              ferramentaDTO.data_hora_retirada !== null
                ? ferramentaDTO.data_hora_retirada.date
                : "",
          })
        );
      });
    }

    return {
      listaFerramentasDevolver,
    };
  },

  listarFornecedores: async (context, { paginacao, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let params = {};

    if (search) {
      params.search = search;
    }

    if (paginacao) {
      params.per_page = paginacao.rowsPerPage;
      params.page = paginacao.page;
    }

    let resposta = await api.get(`providers`, { params });

    resposta = resposta.data;

    let listaFornecedores = [];
    resposta.results.data.forEach((grupoDTO) => {
      listaFornecedores.push(
        new Fornecedor({
          id: grupoDTO.id,
          nome: grupoDTO.business_name,
          fantasia: grupoDTO.fantasy_name,
          cnpj: grupoDTO.cnpj,
        })
      );
    });

    paginacao.page = resposta.results.current_page;
    paginacao.rowsPerPage = resposta.results.per_page;
    paginacao.rowsNumber = resposta.results.total;
    return {
      listaFornecedores,
      paginacao,
    };
  },

  listarMovimentacao: async (context, { perPage, page, ferramenta_uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(`ferramentas/status`, {
      params: {
        ferramenta_uuid,
        per_page: perPage,
        page: page,
      },
    });

    resposta = resposta.data;
    let listaMovimentacao = [];

    resposta.result.data.forEach((movimentacaoDTO) => {
      listaMovimentacao.push(
        new Movimentacao({
          uuid: movimentacaoDTO.uuid,
          ferramenta_uuid: movimentacaoDTO.ferramenta_uuid,
          created_at: movimentacaoDTO.created_at,
          deleted_at: movimentacaoDTO.deleted_at,
          documentos: movimentacaoDTO.documentos,
          observacao: movimentacaoDTO.observacao,
          status_anterior: movimentacaoDTO.status_anterior,
          status_atual: movimentacaoDTO.status_atual,
          updated_at: movimentacaoDTO.updated_at,
          user_id: movimentacaoDTO.user_id,
        })
      );
    });

    return {
      listaMovimentacao,
      resposta,
    };
  },

  editarFerramenta: async (
    context,
    {
      uuid,
      unidadeId,
      nome,
      descricao,
      grupo,
      origem,
      serie,
      documento,
      tipo_documento,
      preco,
      patrimonio,
      permanencia,
      fornecedorId,
      responsavelId,
      valor_locacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.put(`ferramentas/${uuid}`, {
      vendor_id: unidadeId,
      nome: nome,
      descricao: descricao,
      grupo_ferramenta_uuid: grupo,
      origem: origem,
      serie: serie,
      documento: documento,
      preco: preco,
      patrimonio: patrimonio,
      tempo_permanencia: permanencia,
      provider_id: fornecedorId,
      responsavel_id: responsavelId,
      tipo_documento,
      valor_locacao,
    });
  },

  consultarFerramenta: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`ferramentas/${uuid}`);
    resposta = resposta.data;

    return {
      resposta,
    };
  },

  listarDocumentos: async (
    context,
    { movimentacao_status_uuid, paginacao }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let params = {};

    if (movimentacao_status_uuid) {
      params.movimentacao_status_uuid = movimentacao_status_uuid;
    }

    if (paginacao) {
      params.per_page = 1000;
      params.page = 1;
    }

    let resposta = await api.get(`ferramentas/status`, { params });
    resposta = resposta.data;

    let listaDocumentos = [];
    resposta.result.data[0].documentos.forEach((documentoDTO) => {
      listaDocumentos.push(
        new Documento({
          uuid: documentoDTO.uuid,
          observacao: documentoDTO.observacao,
          data_criacao: documentoDTO.created_at.date,
          url: documentoDTO.url,
          usuario: documentoDTO.usuario_logado.nome,
        })
      );
    });

    return {
      listaDocumentos,
    };
  },

  retirarFerramenta: async (
    context,
    { ferramentas, uuid, responsavelId, dh_retirada, biometria }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`ferramentas/retirar`, {
      user_id: responsavelId,
      dh_retirada: dh_retirada,
      uuid: uuid,
      ferramentas: ferramentas,
      biometria,
    });
  },

  devolverFerramenta: async (
    context,
    { responsavelId, movimentacao_uuid, dh_devolucao, ferramentas, biometria }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`ferramentas/devolver`, {
      user_id: responsavelId,
      movimentacao_uuid: movimentacao_uuid,
      dh_devolucao: dh_devolucao,
      ferramentas,
      biometria,
    });
  },

  // Cadastrar Grupo

  criarGrupo: async (context, { unidadeId, nome, descricao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`grupo-ferramenta`, {
      vendor_id: unidadeId,
      nome: nome,
      descricao: descricao,
    });

    return response;
  },

  deletarGrupo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.delete(`grupo-ferramenta/${uuid}`);
  },

  deletarDocumento: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.delete(`documento-ferramenta/${uuid}`);
  },

  deletarDocumentoMovimentacao: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.delete(`documento-ferramenta/${uuid}`);
  },

  editarGrupo: async (context, { uuid, nome, descricao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.put(`grupo-ferramenta/${uuid}`, {
      nome: nome,
      descricao: descricao,
    });
  },

  consultarGrupo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`grupo-ferramenta/${uuid}`);
    resposta = resposta.data;

    return {
      resposta,
    };
  },

  listarGrupos: async (
    context,
    { rowsPerPage, page, filtro, categoria_uuid }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(`grupo-ferramenta`, {
      params: {
        per_page: rowsPerPage,
        page,
        nome: filtro,
        categoria_uuid,
      },
    });

    resposta = resposta.data;

    let listaGrupos = [];
    resposta.result.data.forEach((grupoDTO) => {
      listaGrupos.push(
        new Grupo({
          uuid: grupoDTO.uuid,
          nome: grupoDTO.nome,
          descricao: grupoDTO.descricao,
          numero: grupoDTO.numero,
        })
      );
    });

    return {
      listaGrupos,
      resposta,
    };
  },

  listarCategorias: async (context, { per_page, page, nome }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`categoria-ferramenta`, {
      params: {
        per_page,
        page,
        nome,
      },
    });

    return response;
  },

  criarCategoria: async (context, { nome, descricao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`categoria-ferramenta`, {
      nome,
      descricao,
    });

    return response;
  },

  detalharCategoria: async (context, { categoriaUuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`categoria-ferramenta/${categoriaUuid}`);

    return response;
  },

  vincularCategoriaAoGrupo: async (context, { categoria_uuid, grupo_uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`categoria-ferramenta/vincular`, {
      categoria_uuid,
      grupo_uuid,
    });

    return response;
  },

  editarCategoria: async (context, { categoriaUuid, nome, descricao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`categoria-ferramenta/${categoriaUuid}`, {
      nome,
      descricao,
    });

    return response;
  },

  deletarCategoria: async (context, { categoriaUuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`categoria-ferramenta/${categoriaUuid}`);

    return response;
  },

  ///

  criarChecklist: async (context, { unidadeId, descricao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`check-list-ferramenta`, {
      vendor_id: unidadeId,
      descricao: descricao,
    });
  },
  getUsuarioFerramentaVinculo: async (context, { user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let response = await api.get(
      `ferramentas/listar-ferramentas/liberadas-por-funcionario`,
      {
        params: {
          user_id,
        },
      }
    );

    return response;
  },
  desvincularFerramenta: async (context, { idFerramenta, idUsuario }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let response = await api.put(
      `ferramentas/${idFerramenta}/desvincular-usuario/${idUsuario}`
    );

    return response;
  },
  assosiarFerramentas: async (context, { ferramentas, idUsuario }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let response = await api.post(`ferramentas/vincular-ferramentas`, {
      ferramentas,
      user_id: idUsuario,
    });

    return response;
  },
  assosiarUsuariosFerramentas: async (context, { user_id, uuid_toll }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let response = await api.put(
      `ferramentas/${uuid_toll}/vincular-usuario/${user_id}`
    );

    return response;
  },

  criarFornecedor: async (context, { nome, fantasia, cnpj }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`providers`, {
      business_name: nome,
      fantasy_name: fantasia,
      cnpj: cnpj,
    });
  },

  deletarChecklist: async (context, { checklistId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.delete(`check-list-ferramenta/${checklistId}`);
  },

  listarVinculadosUsuario: async (
    context,
    { vendor_id, usuario, ferramenta, current_page, per_page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`ferramentas/vinculadas-por-usuario`, {
      params: {
        vendor_id,
        per_page,
        usuario,
        ferramenta,
        page: current_page,
      },
    });

    return resposta;
  },

  exportarAssociacoes: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`ferramentas/vinculadas-por-usuario`, {
      params: {
        download: "xlsx",
        vendor_id,
      },
    });

    return resposta;
  },

  listarChecklist: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(`check-list-ferramenta`, {
      params: {
        vendor_id: unidadeId,
      },
    });

    resposta = resposta.data;

    let listaChecklist = [];
    resposta.result.forEach((checklistDTO) => {
      listaChecklist.push(
        new Checklist({
          unidadeId: checklistDTO.vendorId,
          checklistId: checklistDTO.uuid,
          descricao: checklistDTO.descricao,
        })
      );
    });

    return {
      listaChecklist,
    };
  },

  listarChecklist2: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(`check-list-ferramenta`, {
      vendor_id: unidadeId,
    });

    return {
      resposta,
    };
  },

  listarFuncionarios: async (
    context,
    { card_id, unidadeId, paginacao, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    try {
      let params = {};
      if (unidadeId) {
        params.vendor_id = unidadeId;
      }
      params.search = search;
      params.card_id = card_id;
      if (paginacao) {
        params.per_page = paginacao.rowsPerPage;
        params.page = paginacao.page;
      }

      let resposta = await api.get("auth/users", { params });
      resposta = resposta.data;

      let listaFuncionarios = [];
      console.log(resposta);
      resposta.results.data.forEach((funcionarioDTO) => {
        listaFuncionarios.push(
          new Funcionario({
            id: funcionarioDTO.id,
            nome: funcionarioDTO.name,
            email: funcionarioDTO.email,
            sap: funcionarioDTO.sap,
            funcao: funcionarioDTO.function,
            biometry: funcionarioDTO.biometry,
          })
        );
      });

      paginacao.page = resposta.results.current_page;
      paginacao.rowsPerPage = resposta.results.per_page;
      paginacao.rowsNumber = resposta.results.total;

      return {
        listaFuncionarios,
        paginacao,
      };
    } catch (error) {
      switch (error.message) {
        case "Network Error":
          console.log("Token expirado");
          break;
        default:
          console.error(error);
          throw error;
      }
    }
  },

  listarUsuarios: async (context, search) => {
    const api = context.rootState.autenticacao.apiLegado;
    try {
      let params = {};

      params = search;

      let resposta = await api.get("auth/users", { params });
      resposta = resposta.data;

      let listaFuncionarios = [];
      resposta.results.data.forEach((funcionarioDTO) => {
        listaFuncionarios.push(
          new Funcionario({
            id: funcionarioDTO.id,
            nome: funcionarioDTO.name,
            email: funcionarioDTO.email,
            sap: funcionarioDTO.sap,
            funcao: funcionarioDTO.function,
          })
        );
      });

      return {
        listaFuncionarios,
      };
    } catch (error) {
      switch (error.message) {
        case "Network Error":
          console.log("Token expirado");
          break;
        default:
          console.error(error);
          throw error;
      }
    }
  },

  relatorioMovimentacoesStatus: async (
    context,
    {
      unidadeId,
      ferramentaId,
      dataInicial,
      dataFinal,
      statusAnterior,
      statusAtual,
      ferramenta,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get("ferramentas/status", {
      params: {
        vendor_id: unidadeId,
        ferramenta_uuid: ferramentaId,
        data_inicial: dataInicial,
        data_final: dataFinal,
        status_anterior: statusAnterior,
        status_atual: statusAtual,
        per_page: "1000",
        ferramenta,
      },
    });

    return {
      resposta,
    };
  },

  relatorioMovimentacoes: async (
    context,
    {
      unidadeId,
      funcionario,
      dataInicialRetirada,
      dataFinalRetirada,
      dataInicialDevolucao,
      dataFinalDevolucao,
      filtroCheckList,
      ferramenta,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(
      "ferramentas/listar-ferramentas/movimentacao",
      {
        params: {
          vendor_id: unidadeId,
          usuario: funcionario,
          data_inicial_retirada: dataInicialRetirada,
          data_final_retirada: dataFinalRetirada,
          data_inicial_devolucao: dataInicialDevolucao,
          data_final_devolucao: dataFinalDevolucao,
          ...(filtroCheckList ? { filtro_check_list: filtroCheckList } : {}),
          per_page: "1000",
          ferramenta,
        },
      }
    );

    resposta = resposta.data;

    let movimentacoes = [];
    resposta.result.data.forEach((relatorioDTO) => {
      movimentacoes.push(
        new RelatorioMovimentacoes({
          unidade: relatorioDTO.vendor,
          funcionario: relatorioDTO.nome,
          descricao: relatorioDTO.descricao,
          ferramenta: relatorioDTO.ferramenta,
          patrimonio: relatorioDTO.patrimonio,
          permanencia: relatorioDTO.tempo_permanencia,
          checkLists:
            relatorioDTO.check_lists ||
            relatorioDTO.checkLists ||
            relatorioDTO.check_list ||
            relatorioDTO.checklist ||
            relatorioDTO.checkList,
          dataInicialRetirada: relatorioDTO.retirada,
          dataInicialDevolucao: relatorioDTO.devolucao,
          preco: relatorioDTO.preco,
        })
      );
    });

    return {
      movimentacoes,
    };
  },

  relatorioFerramentas: async (
    context,
    {
      unidadeId,
      funcionario,
      status,
      per_page,
      page,
      ferramenta,
      codigo,
      patrimonio,
      descricao,
      grupo,
      sub_grupo,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get(
      "ferramentas/listar-ferramentas/simplificada",
      {
        params: {
          vendor_id: unidadeId,
          funcionario: funcionario,
          status: status,
          ferramenta,
          objetos: "check-list,movimento,deposito",
          codigo,
          grupo,
          sub_grupo,
          descricao,
          patrimonio,
          per_page,
          page,
        },
      }
    );
    return {
      resposta,
    };
  },

  relatorioCautela: async (
    context,
    { unidadeId, funcionarioId, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let resposta = await api.get("ferramentas/relatorio-cautela", {
      params: {
        unidade_id: unidadeId,
        usuario_id: funcionarioId,
        data_inicial: dataInicial,
        data_final: dataFinal,
        per_page: "1000",
      },
    });

    return resposta;
  },

  exportarRelatorioMovimentacoes: async (
    context,
    {
      unidadeId,
      funcionario,
      dataInicialRetirada,
      dataFinalRetirada,
      dataInicialDevolucao,
      dataFinalDevolucao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    await api.get("ferramentas/listar-ferramentas/movimentacao", {
      params: {
        vendor_id: unidadeId,
        usuario: funcionario,
        data_inicial_retirada: dataInicialRetirada,
        data_final_retirada: dataFinalRetirada,
        data_inicial_devolucao: dataInicialDevolucao,
        data_final_devolucao: dataFinalDevolucao,
        download: "xlsx",
        per_page: "1000",
      },
    });
  },

  exportarRelatorioMovimentacoesStatus: async (
    context,
    {
      ferramentaId,
      dataInicial,
      dataFinal,
      statusAnterior,
      statusAtual,
      unidadeId,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    await api.get("ferramentas/status", {
      params: {
        vendor_id: unidadeId,
        ferramenta_uuid: ferramentaId,
        data_inicial: dataInicial,
        data_final: dataFinal,
        status_anterior: statusAnterior,
        status_atual: statusAtual,
        download: "xlsx",
      },
    });
  },

  exportarRelatorioFerramentas: async (
    context,
    { unidadeId, funcionario, status }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    await api.get("ferramentas/listar-ferramentas/simplificada", {
      params: {
        vendor_id: unidadeId,
        funcionario,
        status: status,
        download: "xlsx",
        per_page: "1000",
      },
    });
  },

  exportarRelatorioCautela: async (
    context,
    { unidadeId, funcionarioId, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    await api.get("ferramentas/relatorio-cautela", {
      params: {
        unidade_id: unidadeId,
        usuario_id: funcionarioId,
        data_inicial: dataInicial,
        data_final: dataFinal,
        download: "xlsx",
        per_page: "1000",
      },
    });
  },

  uploadDocumentos: async (
    context,
    { transaction_type, transaction_uuid, observacao, imagem }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`documento-ferramenta`, {
      transaction_type: transaction_type,
      transaction_uuid: transaction_uuid,
      observacao: observacao,
      imagem: imagem,
    });
  },

  uploadDocumentosStatus: async (
    context,
    { transaction_type, transaction_uuid, comentario, documento }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`documento-ferramenta`, {
      transaction_type: transaction_type,
      transaction_uuid: transaction_uuid,
      observacao: comentario,
      imagem: documento,
    });
  },

  uploadImagem: async (context, { uuid, imagem }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.put(`ferramentas/${uuid}/upload-imagem`, {
      image: imagem,
    });
  },

  uploadPlanilha: async (
    context,
    { unidade, mapeamento, planilha, repetir_patrimonio }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`manutencao-planilha`, {
      adicional: {
        vendor_id: unidade,
        repetir_patrimonio,
      },
      mapeamento,
      planilha,
    });
  },

  uploadPlanilhaAssociacaoUsuario: async (
    context,
    { adicional, mapeamento, planilha }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`manutencao-planilha`, {
      adicional,
      mapeamento,
      planilha,
    });
    return response;
  },

  uploadCautela: async (context, { observacao, imagem, transaction_uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.post(`documento-ferramenta`, {
      transaction_type: "cautela",
      imagem,
      observacao,
      transaction_uuid,
    });
  },

  listarUsuarios2: async (
    context,
    { vendor_id, perPage, page, search, vinculado_ferramenta }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`auth/users`, {
      params: {
        vendor_id,
        per_page: perPage,
        page,
        search,
        vinculado_ferramenta,
      },
    });

    return resposta;
  },

  criarTransferencia: async (
    context,
    { unidade_origem_id, unidade_destino_id, almox, pedido }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.post(`transferencia-ferramenta`, {
      unidade_origem_id,
      unidade_destino_id,
      almox,
      pedido,
    });

    return resposta;
  },
  getDetalheTransferencia: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`transferencia-ferramenta/${id}`);

    return resposta;
  },
  listarTransferenciasCriada: async (
    context,
    {
      status,
      origem_id,
      destino_id,
      data_final,
      data_inicial,
      per_page,
      current_page,
      numero,
      patrimonio,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`transferencia-ferramenta`, {
      params: {
        status,
        origem_id,
        destino_id,
        data_final,
        data_inicial,
        per_page,
        page: current_page,
        numero,
        patrimonio,
      },
    });

    return resposta;
  },
  listarFerramentasTransferencia: async (
    context,
    { status, page, per_page, nome, unidadeId }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`ferramentas/paginado`, {
      params: {
        vendor_id: unidadeId,
        status,
        page,
        per_page,
        nome,
      },
    });

    return resposta;
  },
  adicionarFerramentas: async (context, { ferramentas, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.put(
      `transferencia-ferramenta/${id}/adicionar-ferramentas`,
      {
        ferramentas,
      }
    );

    return resposta;
  },
  removerFerramentas: async (context, { ferramentas, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.put(
      `transferencia-ferramenta/${id}/remover-ferramentas`,
      {
        ferramentas,
      }
    );

    return resposta;
  },
  enviarTransferencia: async (
    context,
    {
      id,
      solicitante_nome,
      solicitante_matricula,
      solicitante_id,
      expedidor_nome,
      expedidor_matricula,
      expedidor_id,
      transportador_nome,
      transportador_matricula,
      veiculo_placa,
      veiculo_modelo,
      observacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.put(`transferencia-ferramenta/${id}/enviar`, {
      solicitante_nome,
      solicitante_matricula,
      solicitante_id,
      expedidor_nome,
      expedidor_matricula,
      expedidor_id,
      transportador_nome,
      transportador_matricula,
      veiculo_placa,
      veiculo_modelo,
      observacao,
    });

    return resposta;
  },

  excluirTransferencia: async (context, { observacao, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.put(`transferencia-ferramenta/${id}/excluir`, {
      observacao,
    });

    return resposta;
  },
  cancelarTransferencia: async (context, { observacao, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.put(`transferencia-ferramenta/${id}/cancelar`, {
      observacao,
    });

    return resposta;
  },
  uploadTransferencia: async (context, { comentario, id, documento }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.post(`transferencia-ferramenta/${id}/documento`, {
      documento,
      comentario,
    });

    return resposta;
  },
  receberTransferencia: async (context, { observacao, id, rejeitadas }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.put(`transferencia-ferramenta/${id}/receber`, {
      observacao,
      rejeitadas,
    });

    return resposta;
  },
  excluirDocumento: async (context, { documento, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.delete(
      `transferencia-ferramenta/${id}/documento/${documento}`,
      {}
    );

    return resposta;
  },
  documentoCautela: async (context, { id, data_inicial }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`ferramentas/listagem-cautelas/${id}`, {
      params: {
        per_page: 1000,
        data_inicial,
      },
    });

    return resposta;
  },
  excluirDocumentoCautela: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.delete(`documento-ferramenta/${id}`);

    return resposta;
  },
  listarTransferenciasCriadaExportar: async (
    context,
    {
      status,
      origem_id,
      destino_id,
      data_final,
      data_inicial,
      per_page,
      current_page,
      numero,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`transferencia-ferramenta`, {
      params: {
        status,
        origem_id,
        destino_id,
        data_final,
        data_inicial,
        per_page,
        page: current_page,
        numero,
        download: "xlsx",
      },
    });

    return resposta;
  },

  listarTiposDocumento: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ferramentas/tipo-documento/lista`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  // Criar Ferramentas em Massa
  listarProdutosCriados: async (
    context,
    { has_ca, per_page, page, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`products`, {
      params: {
        has_ca,
        page,
        per_page,
        search,
      },
    });

    return response;
  },
  enviarFerramentasEmMassa: async (
    context,
    { vendor_id, ferramentas, imagem, url_imagem }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`ferramentas/carga-ferramenta`, {
      vendor_id,
      ferramentas,
      imagem,
      url_imagem,
    });

    return response;
  },

  // Editar Ferramenta
  listarDocumentosCriados: async (
    context,
    {
      unidadeId,
      nome,
      descricao,
      CategoriaUuid,
      TipoUuid,
      comArquivo,
      ArquivoUuid,
      status,
      vencimento,
      vencimentoEmDias,
      vigencia,
      perPage,
      page,
      vinculadoId,
      origemVinculo,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/documento`, {
      params: {
        unidadeId,
        nome,
        descricao,
        CategoriaUuid,
        TipoUuid,
        comArquivo,
        ArquivoUuid,
        status,
        vencimento,
        vencimentoEmDias,
        vigencia,
        perPage,
        page,
        vinculadoId,
        origemVinculo,
      },
    });

    return response;
  },

  vincularDocumento: async (context, { documentoUuid, origem, vinculados }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/documento/${documentoUuid}/vincular`, {
      origem,
      vinculados,
    });

    return response;
  },

  desvincularDocumento: async (
    context,
    { documentoUuid, origem, vinculados }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `gdd/documento/${documentoUuid}/desvincular`,
      {
        origem,
        vinculados,
      }
    );

    return response;
  },

  // Customização de Ficha de cautela

  receberDadosFichaCautela: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ferramentas/personalizar-cautela/listar`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  getFerramentaQr: async (
    context,
    { vendor_id, codigo, descricao, patrimonio, status, page, per_page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `ferramentas/listar-ferramentas/simplificada`,
      {
        params: {
          vendor_id,
          codigo,
          descricao,
          patrimonio,
          status,
          page,
          per_page,
        },
      }
    );

    return response;
  },

  buscarUsuarioPorCracha: async (context, { card_id, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/auth/users`, {
      params: {
        card_id,
        vendor_id,
        per_page: 1,
      },
    });
    return response;
  },

  criarDadosFichaCautela: async (
    context,
    { vendor_id, titulo, subtitulo, dizeres }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`ferramentas/personalizar-cautela`, {
      vendor_id,
      titulo,
      subtitulo,
      dizeres,
    });

    return response;
  },
};

export const fer = {
  namespaced: true,
  actions,
};
